import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import {
	enableProdMode,
	ErrorHandler,
	importProvidersFrom,
	provideAppInitializer,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, TitleStrategy } from '@angular/router';
import { sessionTrackingInterceptor } from 'src/app/core/auth/interceptors/session-tracking.interceptor';

import { AppComponent } from './app/app.component';
import { ROUTES_CONFIG } from './app/app.routes';
import { AuthInterceptor } from './app/core/auth/interceptors/auth.interceptor';
import { ErrorInterceptor } from './app/core/auth/interceptors/error.interceptor';
import { initializeAppSession } from './app/core/initializers/app-session.initializer';
import { AppTitleStrategy } from './app/core/layout/services/app-title.strategy';
import { HistoryService } from './app/core/layout/services/history.service';
import { CustomErrorHandler } from './app/core/services/custom-error-handler.service';
import { provideUi } from './app/shared/ui/provide-ui';
import { Environment } from './environments/environment';

if (Environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		provideZonelessChangeDetection(),
		provideBrowserGlobalErrorListeners(),
		importProvidersFrom(BrowserModule),
		{
			provide: TitleStrategy,
			useClass: AppTitleStrategy,
		},
		{
			provide: ErrorHandler,
			useClass: CustomErrorHandler,
		},
		DatePipe,
		HistoryService,
		provideHttpClient(withXhr(), withInterceptors([AuthInterceptor, ErrorInterceptor, sessionTrackingInterceptor])),
		provideRouter(ROUTES_CONFIG /*, withComponentInputBinding()*/),
		provideAnimationsAsync(),
		provideUi(),
		provideAppInitializer(initializeAppSession),
	],
}).catch((err) => console.error(err));
